import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { SessionHelper } from '../../../shared/services/localstorage';
import{SpeakerService} from '../../../../globalservices/speaker/speaker.service';
import * as moment from 'moment-timezone';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

// import {EventsService} from '../../../../globalservices/events/events.service';
@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent implements OnInit {
  userObj:any;
  filterObj:any={};
  sort:any={
    startDate:'ASC'
  }
  status:any;
  limit=3;
  start=0;
  events:any;
  todayDate;
  downloadUrl:SafeUrl;
  constructor(private router:Router,private speakerService:SpeakerService,private sanitizer: DomSanitizer,
    ) { }

  ngOnInit() {
    this.todayDate=moment(new Date()).format('YYYY-MM-DD')+' 00:00:00';
    this.userObj = SessionHelper.getSession();
    console.log("this.userObj123",this.userObj);
    this.filterObj.type='UpcomingPrograms';
    this.filterObj.userId=this.userObj.id;
    this.filterObj.brandId=this.userObj.brand_id;
    this.filterObj.startDate= this.todayDate;
    this.getEventsData();
  //  this.downloadFile();

  }


  downloadFile() {
    const blob = new Blob(["BEGIN:VCALENDAR VERSION:2.0 CALSCALE:GREGORIAN BEGIN:VEVENT SUMMARY:Access-A-Ride Pickup DTSTART;TZID=Eastern Standard Time:20130802T103400 DTEND;TZID=Eastern Standard Time:20130802T110400 LOCATION:1000 Broadway Ave.\, Brooklyn DESCRIPTION: Access-A-Ride trip to 900 Jay St.\, Brooklyn STATUS:CONFIRMED SEQUENCE:3 BEGIN:VALARM TRIGGER:-PT10M DESCRIPTION:Pickup Reminder ACTION:DISPLAY END:VALARM END:VEVENT BEGIN:VEVENT SUMMARY:Access-A-Ride Pickup DTSTART;TZID=Eastern Standard Time:20130802T200000 DTEND;TZID=Eastern Standard Time:20130802T203000 LOCATION:900 Jay St.\, Brooklyn DESCRIPTION: Access-A-Ride trip to 1000 Broadway Ave.\, Brooklyn STATUS:CONFIRMED SEQUENCE:3 BEGIN:VALARM TRIGGER:-PT10M DESCRIPTION:Pickup Reminder ACTION:DISPLAY END:VALARM END:VEVENT END:VCALENDAR"], { type: 'text/calendar' });
    
    this.downloadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));

   }

    getEventsData(){
     // ultra
        this.speakerService.getUpcommingEvent(this.sort,this.filterObj,this.limit,this.start)
        .subscribe((result:any)=>{
        this.events=result.data.data;
        for(let i=0;i<this.events.length;i++){

              let date1 = moment(this.events[i].date);

              date1.tz('UTC');
              let year = moment(date1).year();
              let day = moment(date1).date();
              let date = moment(date1, "YYYY-MM-DD").format("MM-DD-YYYY");
              let month = 1 + moment(date1).month();
              // let dayNumber = moment(date).date();
              // let dayNumber = moment(this.events[i].date).date();

              let dayNumber =  date1.date();
          
              this.events[i].dayNumber = dayNumber.toString(); 
              let time =this.events[i].startTime.split(":").join("")
              let endTime =this.events[i].endTime.split(":").join("")
              day = ("0" +day).slice(-2);
              this.events[i].startTime=moment(this.events[i].startTime, ["h:mm"]).format("h:mm A")
              this.events[i].endTime=moment(this.events[i].endTime, ["h:mm"]).format("h:mm A")
              let DTStart;
              let DTEND;

              if(month.toString().length ==1){
              
                  DTStart=year+'0'+month.toString()+day.toString()+'T'+time+'00';
                  DTEND=year+'0'+month.toString()+day.toString()+'T'+endTime+'00';
              
              }else{
              
                DTStart=year+month.toString()+day.toString()+'T'+time+'00';
                DTEND=year+month.toString()+day.toString()+'T'+endTime+'00';
              
              }

              const blob = new Blob(
                // ["BEGIN:VCALENDAR\nVERSION:2.0\nCALSCALE:GREGORIAN\nBEGIN:VEVENT\nSUMMARY:"+this.events[i].topic+"\nDTSTART;TZID=Eastern Standard Time:"+DTStart+"\nDTEND;TZID=Eastern Standard Time:"+DTEND+"\nLOCATION:"+this.events[i].location +"\nDESCRIPTION:"+this.events[i].topic+"\nSTATUS:CONFIRMED\nSEQUENCE:3\nBEGIN:VALARM\nTRIGGER:-PT10M\nDESCRIPTION:"+this.events[i].topic+"\nACTION:DISPLAY\nEND:VALARM\nEND:VEVENT\nBEGIN:VEVENT\nSUMMARY:"+this.events[i].topic+"\nDTSTART;TZID=Eastern Standard Time:"+DTStart+"\nDTEND;TZID=Eastern Standard Time:"+DTEND+"\nLOCATION:"+this.events[i].location+"\nDESCRIPTION:"+this.events[i].topic+"\nSTATUS:CONFIRMED\nSEQUENCE:3\nBEGIN:VALARM\nTRIGGER:-PT10M\nDESCRIPTION:"+this.events[i].topic+"\nACTION:DISPLAY\nEND:VALARM\nEND:VEVENT\nEND:VCALENDAR"], { type: 'text/calendar' });
              ["BEGIN:VCALENDAR\nVERSION:2.0\nCALSCALE:GREGORIAN\nBEGIN:VEVENT\nSUMMARY:"+this.events[i].topic+"\nDTSTART;TZID=Eastern Standard Time:"+DTStart+"\nDTEND;TZID=Eastern Standard Time:"+DTEND+"\nLOCATION:"+this.events[i].location +"\nDESCRIPTION:"+this.events[i].topic+"\nSTATUS:CONFIRMED\nSEQUENCE:3\nBEGIN:VALARM\nTRIGGER:-PT10M\nDESCRIPTION:"+this.events[i].topic+"\nACTION:DISPLAY\nEND:VALARM\nEND:VEVENT\nEND:VCALENDAR"], { type: 'text/calendar' });
              this.downloadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
            
              this.events[i].downloadUrl=this.downloadUrl;
            if(this.events[i].topic===null){

                this.events[i].downloadIcs="event.ics";
            }else{

              this.events[i].downloadIcs=this.events[i].topic+".ics";
            }

        }
        console.log("this.events",this.events)
        })
  }
  
    onEventdetails(event){
      this.router.navigate(['eventdetails/',event.eventId]);
    }
    onExpenseDetails(event){
      this.router.navigate(['expenses/',event.eventId]);
    }
}
